var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#000",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.941 31.786L.613 60.114a2.014 2.014 0 102.848 2.849l28.541-28.541 28.541 28.541c.394.394.909.59 1.424.59a2.014 2.014 0 001.424-3.439L35.064 31.786 63.41 3.438A2.014 2.014 0 1060.562.589L32.003 29.15 3.441.59A2.015 2.015 0 00.593 3.439l28.348 28.347z"
  })));
};

export default SvgClose;